import { FC } from "react"
import { TravelersDetail } from "../../../module/travelers/containers/detail"

export const TravelersDetailPage: FC = () => <TravelersDetail />
